import { connect } from 'react-redux'

import {
  getUsers,
  setCountryFilter,
} from 'reduxpath/ducks/User/List'

import CountryFilter from './units'

const mapStateToProps = state => ({
  selectionsCountry: state.Reference.selectionsCountry,
})

const mapDispatchToProps = dispatch => ({
  setCountryFilter(emailFilter) {
    return (event) => {
      const countryFilter = event.target.value
      const qs = {
        skip: 0,
        where: {
          or: [
            { hasAgreedTnc: true },
          ],
        },
      }

      if (countryFilter) {
        qs.where.country = countryFilter
      }

      if (emailFilter) {
        qs.where.email = `${emailFilter}%`
      }
      dispatch(setCountryFilter(countryFilter))
      dispatch(getUsers(qs))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(CountryFilter)
